import SubscriptionService from "@/services/SubscriptionService";

export const fetchAccountPlanFeatures = async ({ commit }, id) => {
  const planFeatures = await SubscriptionService.getAccountPlanFeatures(id);

  commit("setAccountPlanFeatures", planFeatures);
};
